import { combineReducers } from 'redux'
import alertReducer from './alertReducer'
import authReducer from './authReducer'
import { getCertificateListTanantAdmin, getCertificateListUser, getCertificateThemeList, verifyCertificate, createCertificateTheme, updateCertificateTheme, deleteCertificateTheme } from './certificateReducer'
import { couponDeleteReducer, couponGenerationReducer, couponListingReducer, couponVerificationReducer, couponActiveInactiveReducer } from './couponReducer'

export default combineReducers({
	authReducer,
	alertReducer,
	couponVerificationReducer,
	couponGenerationReducer,
	couponListingReducer,
	couponDeleteReducer,
	couponActiveInactiveReducer,
	getCertificateListTanantAdmin,
	verifyCertificate,
	getCertificateThemeList,
	getCertificateListUser,
	createCertificateTheme,
	updateCertificateTheme,
	deleteCertificateTheme,
})
